exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-panel-with-heading{display:block;border-radius:4px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.05),0 0 4px 0 rgba(0,0,0,.05)}adp-panel-with-heading panel-content,adp-panel-with-heading panel-header{display:block}adp-panel-with-heading h3{display:inline-block;vertical-align:top;margin-bottom:0;color:#0e5061}adp-panel-with-heading .panel-header{border-bottom:1px solid #e4e4e4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpPanelWithHeading/adpPanelWithHeading.less
// module id = 522
// module chunks = 0